import * as yup from 'yup';

import { ClaimContext } from '../../types';
import { useYupValidation } from '../../../../../hooks/useYupValidation';
import { ClaimStepContainerProps } from '../ClaimStepContainer';

/**
 * Handles "Next", "Back" and "Save Draft" buttons clicks with validation
 */
export function useValidateStep<TValues extends yup.AnyObject, TContext = yup.AnyObject>(
  schema: yup.ObjectSchema<TValues, TContext>,
  claim: Partial<ClaimContext>,
  validationContext: TContext,
  stepProps: Pick<ClaimStepContainerProps, 'onNext' | 'onSaveDraft' | 'onBack'>
) {
  const { onNext, onSaveDraft, onBack } = stepProps;
  const { validate, errors, isFieldRequired } = useYupValidation(schema);

  const onClickNext = () => {
    if (validate(claim, validationContext) && onNext) {
      onNext();
    }
  };

  const onClickSaveDraft = () => {
    if (validate(claim, { ...validationContext, isDraftMode: true }) && onSaveDraft) {
      onSaveDraft();
    }
  };

  const onClickBack = () => {
    if (validate(claim, { ...validationContext, isDraftMode: true }) && onBack) {
      onBack();
    }
  };

  return { onClickNext, onClickBack, onClickSaveDraft, errors, isFieldRequired };
}
